// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2523) return "static/chunks/25c8a87d-4d9208ee176e60a9.js";
	if (chunkId === 1810) return "static/chunks/1810-ab06640e3c8267b0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1324":"5aed717d60d2322a","2902":"621954de87c3e092","2959":"3d6c50ad19b25c9d","3056":"cacd0cf5bcc8b995","4179":"2e698a1aa2ad9aeb","5330":"e9135b02c034f90f","5855":"69cb0d92818cacf3"}[chunkId] + ".js";
};